module.exports = __webpack_public_path__ + "static/capsule-preview-corbeau-3.69b6eeab.png";


//////////////////
// WEBPACK FOOTER
// ./images/capsule-preview-corbeau-3.png
// module id = 897
// module chunks = 168707334958949